import { ifAuthenticated } from "@/router";

export default [
  // State Page
  {
    path: "/state-pages",
    name: "statePagesIndex",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "state_pages" */ "@/views/location/State.vue")
  },

  // City Page
  {
    path: "/city-pages",
    name: "cityPagesIndex",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "city_pages" */ "@/views/location/City.vue")
  },

  // Alt Cities Pages
  {
    path: "/alt-cities-pages",
    name: "altCitiesPagesIndex",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "city_pages" */ "@/views/location/alt-cities/Index.vue")
  },
  {
    path: "/alt-cities-pages/create",
    name: "altCitiesPagesCreate",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "city_pages" */ "@/views/location/alt-cities/Create.vue")
  },
  {
    path: "/alt-cities-pages/:altCitiesPageId/edit",
    name: "altCitiesPagesEdit",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "city_pages" */ "@/views/location/alt-cities/Edit.vue")
  }

];
